export const getImageUrl = (
	filename: string | null | undefined,
	res: '2048px' | '1024px' | '256px' | '512px' | '513px' | 'original' = '1024px'
) => {
	if (!filename) {
		return '';
	}

	const width = res === 'original' ? '' : `?width=${res.slice(0, -2)}`;
	return `https://resources.heni.com/${filename}${width}`;
};
